import type { FaireProductEntity } from "../../entity_types/product";

export const p_t7uw6aq3c6: FaireProductEntity = {
  token: "p_t7uw6aq3c6",
  type: "product",
  name: "Lavender Ribbed Gown",
  brandToken: "b_bq2ct7tp",
  brandName: "Hounds and Honeys",
  imageUrl:
    "https://cdn.faire.com/fastly/628c452b9d5b57766dcd3edabb12c5f25e3d4d22eeced9b2fc63ab2c57bdd6df.jpeg",
  galleryImageUrls: [],
  priceDollars: 14,
  description:
    "\nHandmade knotted baby gown makes infant easily accessible for diaper changes and snuggles. Buttery soft and stretchy material perfect for your newborn. Comes in 0-3 month size, perfect for 7-13lbs\n\nWash on delicate, hang dry or tumble dry on low.\n",
  tags: [],
  msrpDollars: 25.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:57.386Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
